export default "__VITE_ASSET__CeOJyK_8__"